/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { createAction } from "@reduxjs/toolkit";

export const LEGACY_RECORDING_STATUS = {
  SCHEDULED: "scheduled",
  IN_PROGRESS: "inProgress",
  RECORDED: "recorded"
} as const;

export interface TRecordingScheduled {
  offerId?: string;
  contentId?: string;
  recordingStatus?: string;
  unifiedCollectionId?: string;
}

export const recordingScheduled = createAction<TRecordingScheduled>(
  "recordings/scheduled"
);
